import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from '@material-ui/core';

import { formatVerticali } from './../../../utils/info-moduli';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        padding: '0px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    minWidth: {
        minWidth: '100%',
    },
    red: {
        backgroundColor: '#d9534f52',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#ca535085',
        },
    },
    green: {
        backgroundColor: '#00ff0024',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#00c50069',
        },
    },
    divider: {
        borderTop: '1px solid #00000021'
    },
});


class ModuliVerticali extends Component {
    constructor(props) {
        super(props);

        this.setupChange = this.setupChange.bind(this);
    }

    setupChange(keyName, newValue) {
        if (!this.props.isReadOnly)
            this.props.handleChangeFieldModulo('Verticali', keyName, newValue);
    }

    render() {
        const { classes, verticali } = this.props;

        return (
            <List className={classes.root}>


                {
                    Object.keys(verticali).map((keyName, i) => {
                        const labelId = `checkbox-list-label-${keyName}`;

                        return (
                            <ListItem className={`${verticali[keyName] === true ? classes.green : classes.red} ${keyName !== 'FreshGross' ? classes.divider : null}`}
                                key={keyName}
                                role={undefined}
                                dense
                                button
                                onClick={e => { this.setupChange(keyName, !verticali[keyName]) }}
                            >
                                <ListItemIcon >
                                    <Checkbox
                                        edge="start"
                                        checked={verticali[keyName]}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={formatVerticali(keyName)} />
                            </ListItem>
                        );
                    })

                }

            </List>

        );

    }
}

ModuliVerticali.propTypes = {
    verticali: PropTypes.shape({}).isRequired,
    handleChangeFieldModulo: PropTypes.func.isRequired,

    isReadOnly: PropTypes.bool.isRequired
};

export default withStyles(styles)(ModuliVerticali);